import { FC } from 'react';
//components
import SidebarList from 'components/common/SidebarList';
//constants
import { SUPER_ADMIN_SIDEBAR_LIST } from 'constants/index';

const SuperAdminSidebar: FC = (): JSX.Element => <SidebarList list={SUPER_ADMIN_SIDEBAR_LIST} />;

export default SuperAdminSidebar;
